import React from 'react';
import Loading from '../Loading';

const CustomLoading: React.FC<{ columns?: unknown }> = ({ columns: _columns }) => {
  return (
    <div className="ag-overlay-loading-wrapper">
      <Loading size={35} color="primary" />
    </div>
  );
};

export default CustomLoading;
